import { render, staticRenderFns } from "./printer.vue?vue&type=template&id=5c1ad2ad&scoped=true&"
import script from "./printer.vue?vue&type=script&lang=js&"
export * from "./printer.vue?vue&type=script&lang=js&"
import style0 from "./printer.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c1ad2ad",
  null
  
)

export default component.exports